var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCGrass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 36,
    viewBox: "0 0 77 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2119 40.6613C77.2119 30.4831 77.2024 22.5304 76.371 13.507C75.8656 7.98548 73.9996 1.24367 68.5104 0.140289C63.9376 -0.78075 59.79 3.00626 57.2627 6.88678C54.1733 11.6276 52.1042 17.0229 51.235 22.6005C53.46 17.8364 48.2826 11.8333 43.039 12.6C37.7954 13.3668 34.4414 19.5476 35.9437 24.5829C33.0668 20.5761 27.776 18.4161 22.882 19.2437C17.988 20.0759 13.727 23.8535 12.3618 28.5803C7.37335 25.5694 -0.208551 29.9595 -0.000698245 35.7335C22.4994 41.0494 44.8341 47.0338 66.9751 53.6634L77.2072 40.666L77.2119 40.6613Z",
    fill: "#72AD5C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6291 8.48575C66.451 10.7767 66.8384 13.1097 67.0699 15.4426C67.2872 17.7803 67.3013 20.1273 67.1407 22.4556C66.9801 24.7886 66.6353 27.1076 66.092 29.3938C65.5346 31.6754 64.8213 33.9335 63.6828 36.0842C63.3143 33.6811 63.2624 31.3668 63.2529 29.0619C63.2577 26.7616 63.3521 24.48 63.5127 22.2032C63.6734 19.9263 63.9048 17.6587 64.2213 15.3772C64.5567 13.0956 64.9299 10.8094 65.6291 8.48108V8.48575Z",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2282 19.1923C43.9085 20.4452 44.2769 21.6094 44.6123 22.7549C44.9288 23.9003 45.165 25.0224 45.3351 26.1585C45.5099 27.2899 45.6138 28.4307 45.6516 29.6182C45.6705 30.8104 45.6563 32.0307 45.3729 33.4286C44.225 32.5637 43.4786 31.4743 42.8834 30.3289C42.307 29.1788 41.9244 27.9445 41.7402 26.6868C41.5512 25.4291 41.5559 24.1434 41.7685 22.8764C42 21.6094 42.3968 20.3517 43.2329 19.1923H43.2282Z",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.246 25.8078C21.2664 26.107 21.9655 26.5371 22.5844 27.0047C23.1985 27.4769 23.6803 28.0099 24.0913 28.5943C24.4975 29.1834 24.8235 29.8239 25.0502 30.5579C25.2723 31.2966 25.4234 32.1008 25.3337 33.1527C24.2708 33.0732 23.4772 32.7179 22.7828 32.2784C22.0931 31.8343 21.5404 31.2686 21.0963 30.628C20.657 29.9875 20.3263 29.2722 20.1563 28.4727C19.9909 27.6732 19.9437 26.813 20.246 25.8031V25.8078Z",
    fill: "#050505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCGrass);
export default __webpack_public_path__ + "static/media/C_grass.54f0bfff5d774e91bc1f5f6cc64084ec.svg";
export { ForwardRef as ReactComponent };